<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <h2>库存管理系统</h2>
        <p>请输入您的手机号码登录</p>
      </div>
      
      <a-form
        :model="loginForm"
        :rules="rules"
        @finish="handleLogin"
        layout="vertical"
        class="login-form"
      >
        <a-form-item label="手机号码" name="phone">
          <a-input
            v-model:value="loginForm.phone"
            placeholder="请输入手机号码"
            size="large"
            :prefix="h(PhoneOutlined)"
          />
        </a-form-item>
        
        <a-form-item label="密码" name="password">
          <a-input-password
            v-model:value="loginForm.password"
            placeholder="请输入密码（可选）"
            size="large"
            :prefix="h(LockOutlined)"
          />
        </a-form-item>
        
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            size="large"
            block
            :loading="loading"
          >
            登录
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { reactive, ref, h } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { PhoneOutlined, LockOutlined } from '@ant-design/icons-vue'
import { authApi } from '@/api'
import { usePermissionStore } from '@/store/permission'

export default {
  name: 'Login',
  setup() {
    const router = useRouter()
    const permissionStore = usePermissionStore()
    const loading = ref(false)

    const loginForm = reactive({
      phone: '',
      password: ''
    })

    const rules = {
      phone: [
        { required: true, message: '请输入手机号码', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
      ]
    }

    const handleLogin = async (values) => {
      loading.value = true
      try {
        const result = await authApi.login(values)

        // 存储登录信息
        localStorage.setItem('sessionId', result.data.sessionId)
        localStorage.setItem('userId', result.data.userId)
        localStorage.setItem('userInfo', JSON.stringify(result.data.data))

        // 加载用户权限数据
        try {
          await permissionStore.loadUserPermissions()
          message.success('登录成功')
          router.push('/')
        } catch (permError) {
          console.error('加载权限失败:', permError)
          message.warning('登录成功，但加载权限失败，请刷新页面')
          router.push('/')
        }
      } catch (error) {
        console.error('登录失败:', error)
      } finally {
        loading.value = false
      }
    }
    
    return {
      loginForm,
      rules,
      loading,
      handleLogin,
      h,
      PhoneOutlined,
      LockOutlined
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-box {
  width: 400px;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-header h2 {
  color: #1890ff;
  margin-bottom: 8px;
}

.login-header p {
  color: #666;
  margin: 0;
}

.login-form {
  margin-top: 20px;
}
</style>